<template>
    <AdminSelect v-model="modelValue" :options="shippingOptions" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

const shippingOptions = ref([]);

const loadShippingOptions = async () => {
    const { data } = await axios.get(route('delivery.admin.shipping-options.select'));
    shippingOptions.value = data;
};

const modelValue = defineModel({
    type: Number,
});

onMounted(() => {
    loadShippingOptions();
});
</script>
